import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../environments/environment";

import { ICustomerFileRequest } from "../../core/interfaces/customer-file-request.interface";

@Injectable({
  providedIn: "root",
})
export class AuthenticationRemoteService {
  constructor(private httpClient: HttpClient) {}

  getCredentialsForUploadFiles(
    documentType: string,
    documentId: number,
    extension: string,
  ): Observable<object> {
    return this.httpClient.get(
      environment.serverUrlSalaryLoans +
        "credentials/client/" +
        documentType +
        "/" +
        documentId +
        "/" +
        extension,
    );
  }

  getCredentialsForUploadFilesNewClient(
    dataCustomer: ICustomerFileRequest,
  ): Observable<object> {
    return this.httpClient.post(
      environment.serverUrlSalaryLoans + "credentials/client",
      dataCustomer,
    );
  }
}
